import type { PropsWithChildren } from "react";
import { StyledWrapper, StyledCloseButton } from "./styles";
import type { BaseActivatedPanelProps } from "./types";

const BaseActivatedPanel = (props: PropsWithChildren<BaseActivatedPanelProps>) => {
    const { className, children, hideCloseButton, onDeactivate } = props;

    return (
        <StyledWrapper className={className}>
            {children}
            {hideCloseButton ? null : (
                <StyledCloseButton
                    type="flat"
                    iconName="close"
                    iconSize="14px"
                    onClick={onDeactivate}
                    dataAutomation="table-actions-panel.close-button"
                />
            )}
        </StyledWrapper>
    );
};

export default BaseActivatedPanel;
